module.exports = __webpack_public_path__ + "static/media/Lucie-Skokanova.13ce3a58.jpg";